import { useState, useEffect } from 'react';
import type { Community } from '../types';

// Static list of community targets. Status reflects what's actually live in the
// app today: Venezuela is the launch community; everything else is incubating.
// Counts were intentionally removed — fabricating them was the previous bug.
const defaultCommunities: Community[] = [
  {
    id: 'venezuela',
    name: 'Venezuela',
    flag: '🇻🇪',
    status: 'active',
    color: '#820000',
    isPublic: true,
  },
  {
    id: 'ecuador',
    name: 'Ecuador',
    flag: '🇪🇨',
    status: 'incubating',
    color: '#FFD100',
    isPublic: true,
  },
  {
    id: 'brazil',
    name: 'Brazil',
    flag: '🇧🇷',
    status: 'incubating',
    color: '#009739',
    isPublic: true,
  },
  {
    id: 'spain',
    name: 'España',
    flag: '🇪🇸',
    status: 'incubating',
    color: '#AA151B',
    isPublic: true,
  },
  {
    id: 'colombia',
    name: 'Colombia',
    flag: '🇨🇴',
    status: 'incubating',
    color: '#FCD116',
    isPublic: true,
  },
  {
    id: 'global',
    name: 'Everywhere Else',
    flag: '🌎',
    status: 'incubating',
    color: '#4A90D9',
    isPublic: true,
  },
];

interface UseCommunities {
  communities: Community[];
  loading: boolean;
  error: string | null;
}

export function useCommunities(): UseCommunities {
  const [communities, setCommunities] = useState<Community[]>(defaultCommunities);
  const [loading] = useState(false);
  const [error] = useState<string | null>(null);

  useEffect(() => {
    setCommunities(defaultCommunities);
  }, []);

  return { communities, loading, error };
}
